/*
 * @Author: weiShu
 * @Date: 2025-12-29 15:40:44
 * @LastEditors: weiShu
 * @LastEditTime: 2026-04-24 10:39:03
 * @FilePath: \health-commission-new-2\src\router\index.js
 * @Description: 
 */
import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/components/tabbar'
Vue.use(VueRouter)
// const originalPush = VueRouter.prototype.push
// const originalReplace = VueRouter.prototype.replace
// VueRouter.prototype.push = function push(location) {
//   return originalPush.call(this, location).catch(err => err)
// };
// VueRouter.prototype.replace = function push (location, onResolve, onReject) {
//     if (onResolve || onReject) return originalReplace.call(this, location, onResolve, onReject)
//     return originalReplace.call(this, location).catch(err => err)
// }
const routes = [ 
    {
        path: '/bind',
        title: '绑定账号',
        name: 'bind',
        component: () => import('@/views/login/bind.vue'),
    },
    {
        path: '/',
        redirect: '/knowledge',
        component: Layout,
        children: [
            {
                path: 'knowledge',
                name: 'knowledge',
                component(receive) {
                    require(['@/views/knowledge/index.vue'], receive)
                },
                meta: {
                    title: '知识学习',
                    navIndex: 1,
                },
            },
            {
                path: 'knowledge/detail',
                name: 'knowledgeDetail',
                component(receive) {
                    require(['@/views/knowledge/detail.vue'], receive)
                },
                meta: {
                    title: '知识学习详情',
                    navIndex: 1,
                },
            }
        ],
    },
    {
        path: '/course',
        component: Layout,
        children: [
            {
                path: '',
                name: 'course',
                component(receive) {
                    require(['@/views/course/index.vue'], receive)
                },
                meta: {
                    title: '课程学习',
                    navIndex: 2,
                },
            },
            {
                path: 'type',
                name: 'courseTypeList',
                component(receive) {
                    require(['@/views/course/type-list.vue'], receive)
                },
                meta: {
                    title: '课程学习',
                    navIndex: 2,
                },
            }
        ],
    },
    {
        path: '/course/detail',
        name: 'courseDetail',
        component(receive) {
            require(['@/views/course/detail.vue'], receive)
        },
        meta: {
            title: '课程学习详情',
        },
    },
    {
        component: Layout,
        path: '/evaluation',
        children: [
            {
                path: '',
                name: 'evaluation',
                component(receive) {
                    require(['@/views/evaluation/index.vue'], receive)
                },
                meta: {
                    title: '测评考试',
                    navIndex: 3,
                },
            }
        ],
    },
    {
        path: '/my',
        component: Layout,
        children: [
            {
                path: '',
                name: 'my',
                component(receive) {
                    require(['@/views/my/index.vue'], receive)
                },
                meta: {
                    title: '我的',
                    navIndex: 4,
                },
            }
        ],
    },
    {
        path: '/exam-detail',
        name: 'examDetail',
        component(receive) {
            require(['@/views/evaluation/detail.vue'], receive)
        },
        meta: {
            title: '考试详情',
        },
    },
    {
        path: '/profile',
        name: 'profile',
        component(receive) {
            require(['@/views/my/profile.vue'], receive)
        },
        meta: {
            title: '个人信息',
        },
    },
    {
        path: '/exam-paper',
        name: 'examPaper',
        component(receive) {
            require(['@/views/evaluation/exam-paper.vue'], receive)
        },
        meta: {
            title: '考试作答',
        },
    },
    {
        path: '/exam-paper-practice',
        name: 'examPaperPractice',
        component(receive) {
            require(['@/views/evaluation/exam-paper-practice.vue'], receive)
        },
        meta: {
            title: '模拟考试',
        },
    },
    {
        path: '/my/resultQuery',
        name: 'myResultQuery',
        component(receive) {
            require(['@/views/my/resultQuery.vue'], receive)
        },
        meta: {
            title: '成绩查询',
        },
    },
    {
        path: '/my/certificate',
        name: 'certificate',
        component(receive) {
            require(['@/views/my/certificate.vue'], receive)
        },
        meta: {
            title: '我的证书',
        },
    },
    {
        path: '/my/exam-result-detail',
        name: 'examResultDetail',
        component(receive) {
            require(['@/views/my/exam-result-detail.vue'], receive)
        },
        meta: {
            title: '成绩详情',
        },
    },
    {
        path: '/my/exam-record',
        name: 'examRecord',
        component(receive) {
            require(['@/views/my/exam-record.vue'], receive)
        },
        meta: {
            title: '考试记录',
        },
    },
    {
        path: '/my/certificate-list',
        name: 'certificateList',
        component(receive) {
            require(['@/views/my/certificate-list.vue'], receive)
        },
        meta: {
            title: '培训证明',
        },
    },
    {
        path: '/my/order-list',
        name: 'orderList',
        component(receive) {
            require(['@/views/my/order-list.vue'], receive)
        },
        meta: {
            title: '我的订单',
        },
    },
    {
        path: '/my/health-report',
        name: 'healthReport',
        component(receive) {
            require(['@/views/my/health-report.vue'], receive)
        },
        meta: {
            title: '健康报告',
        },
    },
    {
        path: '/my/dosage-report',
        name: 'dosageReport',
        component(receive) {
            require(['@/views/my/dosage-report.vue'], receive)
        },
        meta: {
            title: '个人剂量',
        },
    },
]
const router = new VueRouter({
   // mode: 'history',
    routes
})

export default router